import React, { createContext, useContext } from "react";
import BRANDING_CONFIG from "../config/branding";
import { getDomain } from "../utils/getDomain";

const BrandingContext = createContext();

export const BrandingProvider = ({ children }) => {
    const domain = getDomain();
    // const config = BRANDING_CONFIG[domain] || BRANDING_CONFIG["domain1.com"];
    const config = BRANDING_CONFIG[domain] || BRANDING_CONFIG["app.onlinemasterscolleges.com"];


    return (
        <BrandingContext.Provider value={config}>
            {children}
        </BrandingContext.Provider>
    );
};

export const useBranding = () => useContext(BrandingContext);
